import { render } from "./App.vue?vue&type=template&id=3b1c0e0e"
const script = {}
script.render = render

export default script